import { combineReducers } from '@reduxjs/toolkit';
import { reducer as ambassadorDetailsPageReducer } from '../Ambassadors/AmbassadorDetailsPage/redux/reducers';
import { reducer as experienceDetailsPageReducer } from '../ExperienceDetailsPage/redux/reducers';
import { reducer as partnerDetailsPageReducer } from '../PartnerDetailsPage/redux/reducers';
export const reducer = combineReducers({
    experienceDetailsPage: experienceDetailsPageReducer,
    partnerDetailsPage: partnerDetailsPageReducer,
    ambassadorDetailsPage: ambassadorDetailsPageReducer,
});
